import React from 'react';
import './Services.css'
import { Link } from 'react-router-dom';

import { FaCode, FaDatabase, FaJsSquare, FaReact, FaSign, FaUpload } from 'react-icons/fa';
import { MdDashboardCustomize } from "react-icons/md";
import { TbBrandFirebase } from "react-icons/tb";
import { BsCloudUpload } from "react-icons/bs";

const Services = () => {
    const servicesInfo = [
        {
            id: 1,
            title: 'Landing page design',
            img: <FaCode className='social-icon text-warning' />,
            des: ['html', 'css', 'bootstrap', 'javascript']
        },
        {
            id: 2,
            title: 'Web Design & Development',
            img: <FaReact className='social-icon text-info' />,
            des: ['html', 'css', 'bootstrap/tailwind css', 'javascript', 'react']
        },
        {
            id: 3,
            title: 'Dashboard or Admin panel Design',
            img: <MdDashboardCustomize className='social-icon text-light' />,
            des: ['html', 'css', 'bootstrap/tailwind css', 'javascript', 'react']
        },
        {
            id: 4,
            title: 'Implement Firebase in React App',
            img: <TbBrandFirebase className='social-icon text-danger' />,
            des: ['react js', 'firebase']
        },
        {
            id: 5,
            title: 'Mongodb Database Connection',
            img: <FaDatabase className='social-icon text-success' />,
            des: ['react js', 'mongodb']
        },
        {
            id: 6,
            title: 'Upload Website in Live Server',
            img: <BsCloudUpload className='social-icon text-primary' />,
            des: ['firebase', 'Shared Hosting']
        },
    ]

    return (
        <div className='service-section'>
            <div className='container'>
                <div className='text-center'>
                    <h2 className='heading-two'>What I do </h2>
                    <p><span className='text-uppercase text-light'>my</span> <span className='text-capitalize heading-three'>services</span></p>
                </div>
                <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 pb-5">
                    {
                        servicesInfo.map(service =>
                            <div class="col">
                                <div class="card h-100 pb-3 text-light service-card">
                                    <div class="card-body">
                                        <p className='fs-1 text-center'>{service.img}</p>
                                        <h3 class="card-title py-3"> {service.title} </h3>
                                        <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                    </div>
                                    <Link to='/contact' className="btn btn-portfolio mx-auto"><span>CONTACT</span> </Link>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default Services;